import { useEffect } from "react";

/**
 * Apparition au défilement. Uniquement sur les blocs de contenu, jamais sur un
 * élément interactif ni sur un résultat (docs/DESIGN.md §6). Le CSS neutralise
 * l'effet sous `prefers-reduced-motion: reduce`.
 */
export function useReveal(deps: unknown[] = []): void {
  useEffect(() => {
    const targets = Array.from(document.querySelectorAll<HTMLElement>(".reveal:not(.in)"));
    if (targets.length === 0) return;

    if (typeof window.IntersectionObserver !== "function") {
      targets.forEach((el) => el.classList.add("in"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 },
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
